import i18next from "i18next";
import nl from './nl.json';
import es from './es.json';
import LanguageDetector from "i18next-browser-languagedetector";

export const init = () => {
  return i18next
    .use(LanguageDetector)
    .init({
      debug: true,
      supportedLngs: ['nl', 'es'],
      detection: {
        order: ['querystring', 'navigator'],
        lookupQuerystring: 'lang',
      },
      fallbackLng: 'nl',
      resources: { nl, es }
    });
}
